import {
  DataManagerColunaCalculadaGetter,
  DataManagerColunaCriterio,
  DataManagerColunaGrupo,
} from '../contracts/data-manager.model';
import { DataManagerGrupo } from './data-manager-grupo';

export class DataManagerProxy<T> {
  private _grupo?: DataManagerGrupo<T>;

  constructor(private dados: T) {}

  get id() {
    const id = (this.dados as any).id;
    if (!id) {
      throw new Error('Proxy não tem propriedade id');
    }
    return id;
  }

  get dadosOriginais() {
    return this.dados;
  }

  get isGrupo() {
    return false;
  }

  get pai() {
    return this._grupo;
  }

  get visivel() {
    return !this._grupo ? true : this._grupo.expandido && this._grupo.visivel;
  }

  set grupo(grupo: DataManagerGrupo<T>) {
    this._grupo = grupo;
    grupo.adicionarProxy(this);
  }

  get(
    coluna: {
      id: string;
      tipoColuna: string;
      path?: string[];
      criterio?: DataManagerColunaCriterio;
      dadoAdicional?: string;
      getter?: DataManagerColunaCalculadaGetter;
      lookup?: (dadosOriginais: any) => any;
    },
    semLookup: boolean = false
  ) {
    if (coluna.tipoColuna === 'calculada' && coluna.getter) {
      return coluna.getter(this);
    }

    const obj = this.dados as any;

    if (!coluna.path || coluna.path.length === 0) {
      return obj[coluna.id] ?? '';
    }

    const valor =
      (coluna.path.reduce((prev, curr) => {
        prev = prev ? prev[curr] : '';
        return prev;
      }, obj) ||
        obj[coluna.id]) ??
      '';

    if (coluna.tipoColuna === 'dadoAdicional' && coluna.lookup) {
      return coluna.lookup(valor);
    }

    return coluna.lookup && !semLookup ? coluna.lookup(valor) : valor;
  }

  resetGrupo() {
    this._grupo = undefined;
  }

  totalizarColuna(colunaTotal: DataManagerColunaGrupo) {
    const valor = this.get(colunaTotal) || 0;
    if (this._grupo) {
      this._grupo.totalizarColuna(colunaTotal, valor);
    }
  }
}
